import NoRxDisclaimer from "./NoRxDisclaimer";
export default NoRxDisclaimer;
